{
    "checkout": {
        "billing_address": {
            "title": "Rechnungsadresse"
        },
        "delivery": {
            "delivery_date_info": "Ihre Bestellung wird spätestens geliefert am ",
            "info": "Geben Sie Ihre Versanddetails ein, um die verfügbaren Lieferoptionen zu sehen.",
            "preferences": {
                "express": {
                    "description": "Heute bestellen, übermorgen geliefert!",
                    "label": "Expresslieferung"
                },
                "label": "Welche Lieferung bevorzugen Sie?",
                "regular": {
                    "label": "Standardlieferung"
                }
            },
            "title": "Lieferung"
        },
        "form": {
            "address_finder": {
                "address_filled": "Ihre Adresse wurde ausgefüllt.",
                "invalid_address": "Die eingegebene Adresse wurde nicht gefunden. Bitte überprüfen Sie Ihre Eingabe und versuchen Sie es erneut.",
                "label": "Adresssuche",
                "placeholder": "Beginnen Sie mit der Eingabe, um Ihre Adresse zu suchen",
                "select_address": "Bitte wählen Sie Ihre Adresse aus der Liste aus."
            },
            "city": {
                "label": "Stadt",
                "placeholder": "Stadt",
                "invalid_characters": "Verwende nur Buchstaben, Leerzeichen, Bindestriche (-) und Apostrophe ('), höchstens 100 Zeichen."
            },
            "company": {
                "label": "Firmenname",
                "placeholder": "Firmenname"
            },
            "country": {
                "label": "Land"
            },
            "email": {
                "label": "E-Mail-Adresse",
                "placeholder": "E-Mail-Adresse",
                "label_track_trace": "E-Mail-Adresse für die Sendungsverfolgung"
            },
            "first_name": {
                "label": "Vorname",
                "placeholder": "Vorname"
            },
            "house_number": {
                "label": "Hausnummer",
                "placeholder": "z.B. 1"
            },
            "house_number_suffix": {
                "label": "Zusatz",
                "placeholder": "z.B. A"
            },
            "order_type": {
                "corporate": {
                    "label": "Geschäft"
                },
                "private": {
                    "label": "Privat"
                },
                "title": "Auftragsart"
            },
            "phone_number": {
                "label": "Telefonnummer",
                "placeholder": "Telefonnummer",
                "invalid_characters": "Verwende nur Ziffern, Leerzeichen und + - ( ), höchstens 20 Zeichen."
            },
            "same_address": {
                "label": "Rechnungs- und Lieferadresse sind identisch"
            },
            "street_name": {
                "label": "Straßenname",
                "placeholder": "Straßenname"
            },
            "surname": {
                "label": "Nachname",
                "placeholder": "Nachname"
            },
            "vat_number": {
                "label": "Umsatzsteuer-Identifikationsnummer",
                "placeholder": "Umsatzsteuer-Identifikationsnummer"
            },
            "zipcode": {
                "label": "Postleitzahl",
                "placeholder_example": "z.B. {example}",
                "invalid": "Gib eine gültige Postleitzahl ein, z.B. {example}."
            },
            "save_in_address_book": {
                "label": "Im Adressbuch speichern"
            },
            "newsletter_subscribe": {
                "label": "Halte mich per E-Mail über Neuigkeiten, Inspiration und exklusive Angebote auf dem Laufenden"
            },
            "account_type": {
                "title": "Konto",
                "guest": {
                    "label": "Als Gast fortfahren"
                },
                "create": {
                    "label": "Konto erstellen"
                },
                "email_taken": "Mit dieser E-Mail-Adresse existiert bereits ein Konto.",
                "login_link": "Anmelden",
                "password_required": "Gib zweimal dasselbe Passwort ein, um dein Konto zu erstellen.",
                "privacy_required": "Du musst die Datenschutzerklärung akzeptieren, um dein Konto zu erstellen."
            }
        },
        "payment": {
            "ideal_wero": {
                "description": "iDEAL {'|'} Wero"
            },
            "paypal": {
                "description": "Paypal"
            },
            "title": "Zahlung"
        },
        "shipping_address": {
            "title": "Lieferadresse"
        },
        "customer_addresses": {
            "add_new": "Neue Adresse hinzufügen",
            "create_modal_title": "Neue Adresse",
            "edit_modal_title": "Adresse bearbeiten",
            "delete_modal_title": "Adresse löschen"
        },
        "address_book": {
            "add_new": "Neue Adresse hinzufügen",
            "default_billing": "Standard-Rechnungsadresse",
            "default_shipping": "Standard-Lieferadresse",
            "create_modal": {
                "title_shipping": "Neue Lieferadresse",
                "title_billing": "Neue Rechnungsadresse",
                "confirm": "Speichern",
                "cancel": "Abbrechen"
            },
            "edit_modal": {
                "title": "Adresse bearbeiten",
                "confirm": "Speichern",
                "cancel": "Abbrechen"
            },
            "delete_modal": {
                "title": "Adresse löschen",
                "confirm": "Löschen",
                "cancel": "Abbrechen",
                "description": "Bist du sicher, dass du diese Adresse löschen möchtest? Dies kann nicht rückgängig gemacht werden."
            },
            "save_failed": "Speichern fehlgeschlagen. Bitte versuche es erneut.",
            "delete_failed": "Löschen fehlgeschlagen. Bitte versuche es erneut.",
            "order_only": "Nur für diese Bestellung"
        }
    },
    "components": {
        "buttons": {
            "default": {
                "add_to_cart": {
                    "label": "In den Warenkorb"
                },
                "back": {
                    "label": "Zurück"
                },
                "cancel": {
                    "label": "Abbrechen"
                },
                "close": {
                    "label": "Schließen"
                },
                "confirm": {
                    "label": "Bestätigen"
                },
                "delete": {
                    "label": "Löschen"
                },
                "edit": {
                    "label": "Bearbeiten"
                },
                "next": {
                    "label": "Weiter"
                },
                "previous": {
                    "label": "Zurück"
                },
                "proceed_configuration": {
                    "label": "Fortfahren"
                },
                "save": {
                    "label": "Speichern"
                },
                "start_ordering": {
                    "label": "Jetzt bestellen"
                },
                "upload_photo": {
                    "label": "Foto hochladen"
                }
            },
            "previous_page": {
                "label": "Vorherige Seite"
            },
            "close": {
                "label": "Schließen"
            }
        },
        "discount_blocks": {
            "code_copied": "Code kopiert!"
        },
        "dropdown": {
            "menu_button": {
                "label": "Menü"
            }
        },
        "footer": {
            "newsletter": {
                "title": "Verpassen Sie nie wieder ein Angebot",
                "subtitle": "Melden Sie sich für unseren Newsletter an",
                "email_label": "E-Mail-Adresse",
                "submit_button": "Absenden"
            }
        },
        "header": {
            "all_categories_line_1": "Alle anzeigen",
            "all_categories_line_2": "Kategorien",
            "search_aria_label": "Suchen",
            "search_close_aria_label": "Suche schließen",
            "search_placeholder": "Wonach suchen Sie?",
            "search_all_designs_title": "Alle Designs für ‘{query}’",
            "search_all_designs_label": "Designs",
            "search_suggestions_title": "Suchvorschläge",
            "search_products_title": "Produkte",
            "search_no_results_title": "Keine Designs für ‘{query}’",
            "search_no_results_hint": "Überprüfen Sie die Schreibweise oder versuchen Sie ein allgemeineres Wort.",
            "search_scope_all_products": "Alle Produkte",
            "search_scope_products": "Produkt…",
            "search_all_designs_title_scoped": "Alle Designs für ‘{query}’ in {group}",
            "search_scope_reset": "‘{query}’ in allen Produkten suchen",
            "search_popular_on_title": "Beliebt bei {name}",
            "search_categories_title": "Kategorien"
        },
        "layouts": {
            "login_status": {
                "cart": {
                    "label": "Warenkorb"
                },
                "login": {
                    "label": "Anmelden"
                },
                "welcome": {
                    "label": "Willkommen,"
                },
                "welcome_back": {
                    "label": "Willkommen zurück"
                }
            },
            "mobile_menu_button": {
                "label": "Menü"
            },
            "mobile_menu_drawer": {
                "back_to_categories": "Zurück zu allen Kategorien",
                "close": "Menü schließen",
                "default_title": "Menü",
                "view_all": "Alle {title} anzeigen",
                "expand_submenu": "Untermenü ausklappen"
            }
        },
        "select_menus": {
            "default": {
                "placeholder": "Option wählen"
            }
        },
        "spinners": {
            "default": {
                "label": "Laden..."
            }
        },
        "header_slider": {
            "timer": {
                "days": "d",
                "hours": "h",
                "minutes": "m",
                "seconds": "s"
            }
        },
        "modals": {
            "register": {
                "has_account": "Schon ein Konto?",
                "general_error": "Registrierung fehlgeschlagen. Bitte versuche es erneut."
            },
            "login": {
                "title": "Anmelden"
            }
        },
        "wishlist": {
            "button": {
                "add_aria_label": "Zur Wunschliste hinzufügen",
                "remove_aria_label": "Von der Wunschliste entfernen"
            },
            "header_button": {
                "aria_label": "Wunschliste"
            },
            "toast": {
                "removed": "Von deiner Wunschliste entfernt",
                "undo": "Rückgängig"
            },
            "guest_added": {
                "title": "Wunschliste",
                "success": "Zu deiner Wunschliste hinzugefügt",
                "login_prompt": "{login} oder {register}, um deine Wunschliste auf all deinen Geräten zu speichern und zu teilen.",
                "login": "Melde dich an",
                "register": "erstelle ein Konto",
                "continue_shopping": "Weiter einkaufen",
                "view_wishlist": "Wunschliste ansehen"
            }
        },
        "related_products": {
            "title": "Wähle dein Design",
            "show_all": "Alle ansehen",
            "show_less": "Weniger anzeigen",
            "section_title": "Entdecke mehr aus dieser Kollektion"
        },
        "same_kind_products": {
            "title": "Diese gefallen dir bestimmt auch"
        },
        "same_print_products": {
            "title": "Dieser Print auf weiteren Produkten"
        },
        "pdp_steps": {
            "step_label": "Schritt {number}"
        },
        "pdp_review_videos": {
            "play_label": "Videobewertung von {name} abspielen"
        },
        "video": {
            "play_label": "Video abspielen"
        },
        "slider": {
            "go_to_item": "Zu Element {index} von {total}"
        },
        "lightbox": {
            "counter": "{current} von {total}"
        }
    },
    "general": {
        "checkout": {
            "title": "Kasse"
        },
        "delivery_options": {
            "day_after_tomorrow": {
                "label": "Heute bestellen, <b>übermorgen</b> geliefert!"
            },
            "delivered_in_days": {
                "label": "Lieferung in <b>{days} Tagen</b>"
            },
            "delivered_in_business_days": {
                "label": "Heute bestellt, innerhalb von {days} Arbeitstag geliefert! | Heute bestellt, innerhalb von {days} Arbeitstagen geliefert!"
            },
            "today_delivery": {
                "label": "Heute bestellen, <b>heute</b> geliefert!"
            },
            "tomorrow_delivery": {
                "label": "Heute bestellen, <b>morgen</b> geliefert!"
            }
        },
        "password": {
            "confirmation": {
                "label": "Passwort bestätigen"
            },
            "confirmation_new": {
                "label": "Neues Passwort bestätigen"
            },
            "current": {
                "label": "Aktuelles Passwort"
            },
            "label": "Passwort",
            "mismatch": "Die Passwörter stimmen nicht überein, bitte überprüfen Sie die Felder erneut.",
            "new": {
                "label": "Neues Passwort"
            },
            "requirements": "Verwenden Sie 3 verschiedene Zeichen im Passwort. Mögliche Zeichen: Kleinbuchstaben, Großbuchstaben, Zahlen und Sonderzeichen."
        },
        "price_tables": {
            "entries": {
                "amount_label": "1 Stück | {count} Stück",
                "all_sizes": "Alle Größen"
            },
            "title": {
                "amount": "Anzahl",
                "size": "Größe"
            }
        },
        "prices": {
            "excl_discount": {
                "label": "Preis ohne Rabatt"
            },
            "for": {
                "label": "Für"
            },
            "from": {
                "label": "Von"
            },
            "starting_from": {
                "label": "Ab"
            },
            "title": "Preise",
            "total": {
                "label": "Gesamt"
            }
        },
        "product_description": {
            "title": "Produktbeschreibung"
        },
        "question_and_answers": {
            "no_data": {
                "primary_text": "Es wurden keine Fragen und Antworten gefunden."
            },
            "title": "Fragen und Antworten",
            "subtitle": "Was Kunden am häufigsten fragen."
        },
        "reviews": {
            "buyer": "Käufer",
            "customer_images": "Kundenbilder",
            "view_more_images": "Mehr ansehen",
            "filter_all_stars": "Alle anzeigen",
            "filter_label": "Filter",
            "filter_stars": "1 Stern | {count} Sterne",
            "highest_rated_title": "Kundenrezensionen",
            "no_reviews_title": "Noch keine geschriebenen Rezensionen",
            "no_reviews_description": "Es gibt 1 Bewertung mit {rating} Sternen. | Es gibt {votes} Bewertungen mit durchschnittlich {rating} Sternen.",
            "image_alt": "Bewertungsbild",
            "no_results_for_filter": "Keine Bewertungen für diesen Filter.",
            "read_full_review": "Ganze Bewertung lesen",
            "review_amount": "{count} Bewertung | {count} Bewertungen",
            "review_count": "{votes} Bewertungen, davon {reviewCount} geschrieben",
            "show_all_reviews": "Alle {count} Kundenrezensionen anzeigen",
            "show_less": "Weniger anzeigen",
            "show_original": "Dies ist eine Übersetzung, Original anzeigen",
            "show_star_reviews": "{score}-Sterne-Bewertungen anzeigen",
            "show_translation": "Übersetzung anzeigen",
            "title": "Kundenrezensionen",
            "about": "Über:",
            "read_more": "Mehr lesen",
            "show_all": "Alle {count} anzeigen",
            "votes_count": "1 Bewertung | {count} Bewertungen"
        },
        "shipping_options": {
            "title": "Versandoptionen"
        },
        "show_more_products": "Mehr Produkte anzeigen",
        "stock": {
            "available": "Direkt ab Lager lieferbar"
        },
        "pickup_points": {
            "pickup_location": {
                "confirmed": "Abholpunkt ausgewählt!",
                "select": "Hier abholen"
            }
        },
        "price_table": {
            "filters": {
                "show_less": "Weniger Größen anzeigen",
                "show_more": "Weitere Größen anzeigen"
            }
        },
        "filter_amount_products": "Filter {count} Produkte",
        "show_less_collections": "Weniger Kollektionen anzeigen",
        "show_more_collections": "Mehr Kollektionen anzeigen",
        "show_more": "Mehr anzeigen",
        "show_less": "Weniger anzeigen",
        "product_details": "Produktinformationen"
    },
    "pages": {
        "cart_page": {
            "add_product": "Weiteres Produkt hinzufügen",
            "coupon_applied": "Gutscheincode angewendet.",
            "coupon_apply_failed": "Gutscheincode konnte nicht angewendet werden.",
            "free_shipping_remaining": "Noch {amount} bis zum {free}",
            "free_shipping_goal": "kostenlosen Versand",
            "free_shipping_exception": "Ausgenommen XXL-Pakete",
            "no_items_proceed_shopping_link": "hier",
            "overview_title": "Übersicht",
            "pages_count": "{count} Seiten",
            "quantity_update_failed": "Anzahl kann nicht aktualisiert werden.",
            "remove_modal": {
                "cancel": "Abbrechen",
                "confirm": "Sind Sie sicher, dass Sie dieses Produkt aus Ihrem Warenkorb entfernen möchten?",
                "set_confirm": "Wenn du dieses Produkt entfernst, entfällt der Set-Rabatt auf die übrigen Produkte. Bist du sicher, dass du es entfernen möchtest?",
                "title": "Produkt entfernen",
                "yes": "Ja, entfernen"
            },
            "cart_item": {
                "delete": "Entfernen",
                "edit": "Bearbeiten",
                "edit_failed": "Das Produkt konnte nicht zum Bearbeiten geöffnet werden. Bitte versuche es erneut.",
                "quantity": {
                    "label": "Anzahl"
                },
                "set_count": "{count} Produkt | {count} Produkte",
                "show_details": "Details anzeigen"
            },
            "messages": {
                "success": {
                    "deleted": "Das Produkt wurde aus Ihrem Warenkorb entfernt."
                }
            },
            "no_items": "Ihr Warenkorb ist leer.",
            "overview": {
                "coupon_code": {
                    "button": {
                        "label": "Anwenden"
                    },
                    "cancel": "Abbrechen",
                    "input": {
                        "placeholder": "Gutscheincode eingeben"
                    },
                    "title": "Gutscheincode eingeben"
                },
                "coupon_code_display": "Gutscheincode ({code})",
                "coupon_codes_display": "Gutscheincodes",
                "discount_display": "Rabatt",
                "item_count": "1 Artikel | {count} Artikel",
                "prices": {
                    "discount": "Sie sparen",
                    "grand_total": "Gesamt",
                    "shipping": "Versand",
                    "subtotal": "Zwischensumme",
                    "tax": "MwSt.",
                    "tax_included": "inkl. {amount} MwSt.",
                    "total_incl_tax": "Gesamt (inkl. MwSt.)"
                }
            },
            "proceed_to_checkout": "Zur Kasse gehen",
            "title": "Warenkorb",
            "no_items_proceed_shopping": "Klicken Sie {link}, um weiter einzukaufen.",
            "free_shipping": "Kostenloser Versand",
            "free_shipping_reached": "{free} für Ihre Bestellung",
            "checkout_hint": "Danach: Adresse und Lieferzeitpunkt wählen"
        },
        "category": {
            "clear_filters": "Alle Filter entfernen",
            "filters_title": "Filtern",
            "clear_all": "Alle löschen",
            "selected_count": "{count} ausgewählt",
            "selected_filters": "Ausgewählte Filter",
            "hierarchy_all": "Alle {label}",
            "close_filters": "Filter schließen",
            "filter": "Filter",
            "no_filter_options_available": "Keine Filteroptionen verfügbar",
            "no_image": "Kein Bild",
            "open_grid_view": "Rasteransicht öffnen",
            "open_list_view": "Listenansicht öffnen",
            "open_two_column_view": "Zweispaltige Ansicht öffnen",
            "products": {
                "label": "Produkte",
                "prices": {
                    "recommended_price": "statt"
                }
            },
            "remove_filter": "Filter {filter} entfernen: {value}",
            "show_less_filters": "Weniger anzeigen",
            "show_more_filters": "Mehr anzeigen",
            "show_results": "Ergebnisse anzeigen",
            "show_results_with_count": "{count} Ergebnisse anzeigen",
            "faqs": {
                "title": "Häufig gestellte Fragen"
            },
            "header": {
                "header_description": {
                    "show_more": "Mehr",
                    "show_less": "Weniger"
                }
            },
            "filter_explanation": "Mehr Informationen zu diesem Filter"
        },
        "collection": {
            "delivery_options": {
                "pickup_point": "Abholpunkt (nachhaltige Wahl)"
            }
        },
        "customers": {
            "dashboard": {
                "account_information": {
                    "form": {
                        "assistance_allowed_label": "Fernunterstützung beim Einkaufen zulassen",
                        "assistance_allowed_tooltip": "Dies ermöglicht es Mitarbeitern, mitzuschauen und in Ihrem Namen Handlungen auszuführen, um Ihnen beim Einkaufen besser zu helfen.",
                        "email_label": "E-Mail-Adresse",
                        "first_name_label": "Vorname",
                        "last_name_label": "Nachname",
                        "legend": "Kontoinformationen",
                        "submit_button": "Speichern"
                    },
                    "index": {
                        "intro": "Meine Kontaktdaten und Kontoeinstellungen.",
                        "title": "Kontoinformationen"
                    }
                },
                "address": {
                    "billing_title": "Standard-Rechnungsadresse",
                    "description": "Aktuelle Standard-Rechnungs- und Lieferadresse.",
                    "legend": "Adressbuch",
                    "manage_link": "Adressen verwalten",
                    "shipping_title": "Standard-Lieferadresse"
                },
                "addresses": {
                    "create": {
                        "intro": "Fügen Sie eine neue Adresse zum Adressbuch hinzu.",
                        "title": "Neue Adresse"
                    },
                    "default_cards": {
                        "empty_state": "Noch keine Standardadresse festgelegt."
                    },
                    "edit": {
                        "intro": "Bearbeiten Sie eine bestehende Adresse aus dem Adressbuch.",
                        "title": "Adresse bearbeiten"
                    },
                    "form": {
                        "address_legend": "Adresse",
                        "city_label": "Ort",
                        "company_label": "Firma",
                        "contact_legend": "Kontaktdaten",
                        "countries": {
                            "AT": "Österreich",
                            "BE": "Belgien",
                            "DE": "Deutschland",
                            "FR": "Frankreich",
                            "LU": "Luxemburg",
                            "NL": "Niederlande"
                        },
                        "country_label": "Land",
                        "default_billing_label": "Als Standard-Rechnungsadresse verwenden",
                        "default_shipping_label": "Als Standard-Lieferadresse verwenden",
                        "first_name_label": "Vorname",
                        "last_name_label": "Nachname",
                        "postcode_label": "Postleitzahl",
                        "region_label": "Bundesland/Provinz",
                        "street1_label": "Adresse",
                        "street2_label": "Adresszeile 2",
                        "submit_create_button": "Adresse hinzufügen",
                        "submit_edit_button": "Adresse speichern",
                        "telephone_label": "Telefonnummer"
                    },
                    "index": {
                        "add_address_button": "Adresse hinzufügen",
                        "billing_action_text": "Rechnungsadresse ändern",
                        "billing_title": "Standard-Rechnungsadresse",
                        "delete_modal_cancel_button": "Abbrechen",
                        "delete_modal_confirm_button": "Löschen",
                        "delete_modal_description": "Sind Sie sicher, dass Sie diese Adresse löschen möchten?",
                        "delete_modal_title": "Adresse löschen",
                        "intro": "Meine Adressen und zusätzliche Daten.",
                        "shipping_action_text": "Lieferadresse ändern",
                        "shipping_title": "Standard-Lieferadresse",
                        "title": "Adressbuch"
                    },
                    "list": {
                        "address_column": "Adresse",
                        "city_column": "Ort",
                        "company_column": "Firma",
                        "country_column": "Land",
                        "delete_label": "Löschen",
                        "edit_title": "Bearbeiten",
                        "empty_state": "Es sind noch keine weiteren Adressen festgelegt.",
                        "legend": "Weitere Adressen",
                        "name_column": "Name"
                    }
                },
                "empty_address_state": "Es ist noch keine Adresse festgelegt.",
                "intro": "Willkommen {firstName}! Hier finden Sie alle Ihre Informationen und letzten Bestellungen.",
                "navigation": {
                    "account_information": "Kontoinformationen",
                    "address_book": "Adressbuch",
                    "dashboard": "Dashboard",
                    "logout": "Abmelden",
                    "orders": "Meine Bestellungen",
                    "projects": "Meine Fotobücher",
                    "security": "Sicherheit",
                    "title": "Mein Konto",
                    "wishlist": "Wunschliste"
                },
                "order_history": {
                    "detail": {
                        "header": {
                            "date_label": "Datum"
                        },
                        "index": {
                            "back_button": "Zurück zur Bestellübersicht",
                            "intro": "Detailansicht einer Bestellung.",
                            "title": "Bestellung # {number}"
                        },
                        "info": {
                            "billing_address_title": "Rechnungsadresse",
                            "payment_method_title": "Zahlungsmethode",
                            "shipping_address_title": "Lieferadresse",
                            "shipping_method_title": "Versandmethode"
                        },
                        "items": {
                            "article_number_label": "Art.Nr.",
                            "legend": "Bestellte Artikel",
                            "price_column": "Preis",
                            "product_name_column": "Produktname",
                            "quantity_column": "Anzahl",
                            "subtotal_column": "Zwischensumme"
                        },
                        "totals": {
                            "discount": "Rabatt",
                            "grand_total": "Gesamtsumme (inkl. MwSt.)",
                            "grand_total_excluding_tax": "Gesamtsumme (exkl. MwSt.)",
                            "shipping": "Versand und Bearbeitung",
                            "subtotal": "Zwischensumme",
                            "tax": "MwSt."
                        }
                    },
                    "index": {
                        "intro": "Übersicht meiner aufgegebenen Bestellungen.",
                        "legend": "Meine Bestellungen",
                        "order_count": "{count} Bestellung | {count} Bestellungen",
                        "title": "Meine Bestellungen"
                    },
                    "table": {
                        "date_column": "Datum",
                        "empty_state": "Sie haben noch keine Bestellungen aufgegeben.",
                        "order_number_column": "Bestellnr.",
                        "status_column": "Status",
                        "total_column": "Gesamt",
                        "tracking_column": "Sendungsverfolgung",
                        "view_label": "Ansehen"
                    }
                },
                "orders": {
                    "date_column": "Datum",
                    "empty_state": "Sie haben noch keine Bestellungen aufgegeben.",
                    "legend": "Letzte Bestellungen",
                    "order_number_column": "Bestellnr.",
                    "shipping_to_column": "Versenden an",
                    "status_column": "Status",
                    "total_column": "Gesamt",
                    "view_all_link": "Alle ansehen",
                    "view_link": "Ansehen"
                },
                "profile": {
                    "create": {
                        "intro": "Fügen Sie eine neue Adresse zum Adressbuch hinzu.",
                        "title": "Neue Adresse"
                    },
                    "edit": {
                        "intro": "Bearbeiten Sie eine bestehende Adresse aus dem Adressbuch.",
                        "title": "Adresse bearbeiten"
                    },
                    "edit_link": "Kontoinformationen bearbeiten",
                    "form": {
                        "address_legend": "Adresse",
                        "city_label": "Ort",
                        "company_label": "Firma",
                        "contact_legend": "Kontaktdaten",
                        "country_label": "Land",
                        "default_billing_label": "Als Standard-Rechnungsadresse verwenden",
                        "default_shipping_label": "Als Standard-Lieferadresse verwenden",
                        "first_name_label": "Vorname",
                        "last_name_label": "Nachname",
                        "postcode_label": "Postleitzahl",
                        "region_label": "Bundesland/Provinz",
                        "street1_label": "Adresse",
                        "street2_label": "Adresszeile 2",
                        "submit_create_button": "Adresse hinzufügen",
                        "submit_edit_button": "Adresse speichern",
                        "telephone_label": "Telefonnummer"
                    },
                    "legend": "Kontaktdaten",
                    "list": {
                        "address_column": "Adresse",
                        "city_column": "Ort",
                        "company_column": "Firma",
                        "country_column": "Land",
                        "delete_label": "Löschen",
                        "edit_title": "Bearbeiten",
                        "empty_state": "Es sind noch keine weiteren Adressen festgelegt.",
                        "legend": "Weitere Adressen",
                        "name_column": "Name"
                    }
                },
                "projects": {
                    "index": {
                        "intro": "Meine gespeicherten Projekte und Fotobücher.",
                        "legend": "Meine Fotobücher",
                        "title": "Meine Fotobücher"
                    },
                    "list": {
                        "actions_column": "Aktionen",
                        "empty_state": "Sie haben noch keine Fotobücher gespeichert.",
                        "fallback_text": "Fotobuch Beispiel",
                        "preview_alt": "Vorschau",
                        "preview_link": "Vorschau",
                        "product_column": "Produkt",
                        "project_link": "Zum Projekt",
                        "updated_at_column": "Zuletzt aktualisiert"
                    }
                },
                "security": {
                    "form": {
                        "legend": "Passwort ändern",
                        "submit": "Passwort speichern"
                    },
                    "index": {
                        "intro": "Aktualisieren Sie hier das Passwort Ihres Kontos.",
                        "title": "Sicherheit"
                    }
                },
                "title": "Mein Konto",
                "wishlist": {
                    "index": {
                        "empty_state": "Deine Wunschliste ist leer.",
                        "intro": "Produkte, die du gespeichert hast.",
                        "legend": "Meine Wunschliste",
                        "title": "Wunschliste",
                        "guest_notice": "Auf diesem Gerät gespeichert · {login}, um deine Artikel überall zu sehen",
                        "guest_notice_login": "Melde dich an"
                    },
                    "share": {
                        "button": "Teilen",
                        "title": "Teile deine Wunschliste",
                        "description": "Jeder mit diesem Link kann deine Wunschliste ansehen.",
                        "copy": "Link kopieren",
                        "share_via": "Teilen über…",
                        "copied": "Link kopiert",
                        "email": "E-Mail"
                    },
                    "shared": {
                        "title": "Geteilte Wunschliste",
                        "intro": "Diese Produkte wurden mit dir geteilt."
                    }
                },
                "intro_no_name": "Willkommen! Nachfolgend findest du alle deine Informationen und aktuellen Bestellungen."
            },
            "login": {
                "index": {
                    "create_account": "Konto erstellen",
                    "description": "Wenn Sie ein Konto haben, melden Sie sich bitte mit Ihrer E-Mail-Adresse an.",
                    "email_label": "E-Mail-Adresse",
                    "email_placeholder": "name{'@'}beispiel.de",
                    "forgot_password": "Passwort vergessen?",
                    "intro": "Melden Sie sich an oder erstellen Sie ein Konto, um zu Ihrem Dashboard zu gelangen.",
                    "legend": "Anmelden",
                    "new_customers_description": "Das Erstellen eines Kontos hat viele Vorteile: schnellere Abwicklung, mehr als eine Adresse registrieren, Bestellungen verfolgen und mehr.",
                    "new_customers_legend": "Neue Kunden",
                    "password_label": "Passwort",
                    "password_placeholder": "Geben Sie Ihr Passwort ein",
                    "submit": "Anmelden",
                    "title": "Anmelden",
                    "sso_facebook": "Mit Facebook fortfahren",
                    "sso_google": "Mit Google fortfahren",
                    "sso_separator": "Oder"
                }
            },
            "passwords": {
                "forgot": {
                    "index": {
                        "back_button": "Zurück zur Anmeldung",
                        "description": "Wenn ein Konto mit der angegebenen E-Mail-Adresse existiert, erhalten Sie eine E-Mail.",
                        "email_label": "E-Mail-Adresse",
                        "email_placeholder": "name{'@'}beispiel.de",
                        "intro": "Geben Sie unten Ihre E-Mail-Adresse ein, um einen Link zum Zurücksetzen des Passworts zu erhalten.",
                        "submit_button": "Senden",
                        "title": "Passwort vergessen?"
                    }
                },
                "reset": {
                    "index": {
                        "intro": "Wählen Sie unten ein neues Passwort für Ihr Konto.",
                        "submit": "Neues Passwort festlegen",
                        "title": "Neues Passwort festlegen"
                    }
                }
            },
            "register": {
                "credentials": {
                    "email_label": "E-Mail-Adresse",
                    "legend": "Anmeldedaten",
                    "privacy_link": "Datenschutzerklärung",
                    "privacy_prefix": "Ich stimme der"
                },
                "index": {
                    "back_button": "Zurück zur Anmeldung",
                    "intro": "Erstellen Sie ein neues Konto, um später Ihre Bestellungen, Adressen und Projekte zu verwalten.",
                    "submit_button": "Konto erstellen",
                    "title": "Neues Konto erstellen"
                },
                "profile": {
                    "first_name_label": "Vorname",
                    "last_name_label": "Nachname",
                    "legend": "Persönliche Informationen",
                    "subscribe_label": "Für den Newsletter anmelden"
                }
            }
        },
        "errors": {
            "back_to_home": "Zurück zur Startseite",
            "404": {
                "heading": "Seite nicht gefunden.",
                "description": "Wir konnten die gesuchte Seite nicht finden. Möglicherweise ist der Link abgelaufen oder die Seite wurde verschoben."
            },
            "500": {
                "heading": "Etwas ist schiefgelaufen.",
                "description": "Auf unserer Seite ist ein unerwarteter Fehler aufgetreten. Bitte versuche es später erneut."
            },
            "403": {
                "heading": "Kein Zugriff.",
                "description": "Du hast keine Berechtigung, diese Seite anzuzeigen."
            },
            "503": {
                "heading": "Vorübergehend nicht verfügbar.",
                "description": "Die Website ist vorübergehend nicht verfügbar. Bitte versuche es später erneut."
            },
            "generic": {
                "heading": "Ein Fehler ist aufgetreten.",
                "description": "Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es später erneut."
            }
        },
        "product_detail_page": {
            "share": {
                "label": "Diese Seite teilen",
                "copied": "Link kopiert"
            },
            "product_info": {
                "benefits": {
                    "title": "Die Vorteile von {storeName}",
                    "payment_methods_label": "bezahlen Sie u.a. mit"
                },
                "klarna": {
                    "loading": {
                        "label": "Klarna wird geladen..."
                    }
                },
                "modals": {
                    "product_options_modal": {
                        "overview": {
                            "title": "Übersicht"
                        },
                        "title": "Produktoptionen"
                    }
                },
                "product_button": {
                    "add_to_cart": {
                        "error": "Beim Hinzufügen zum Warenkorb ist ein Fehler aufgetreten.",
                        "loading": {
                            "description": "Du wirst automatisch weitergeleitet.",
                            "label": "In den Warenkorb legen..."
                        },
                        "set_error": "Beim Hinzufügen des Sets ist ein Fehler aufgetreten. Einige Teile liegen eventuell schon im Warenkorb. Prüfe deinen Warenkorb, bevor du es erneut versuchst."
                    },
                    "book_login_modal": {
                        "continue_without_login": "Ohne Anmeldung fortfahren",
                        "continue_without_login_warning": "Wenn du ohne Anmeldung fortfährst, werden deine Fotos nicht gespeichert. Du kannst dein Produkt später nicht mehr bearbeiten oder abschließen.",
                        "description": "Melde dich an, um deinen Fortschritt zu speichern und später an deinem Projekt weiterzumachen.",
                        "email_label": "E-Mail-Adresse",
                        "email_placeholder": "name{'@'}beispiel.de",
                        "forgot_password": "Passwort vergessen?",
                        "general_error": "Anmelden fehlgeschlagen. Überprüfe deine Daten und versuche es erneut.",
                        "no_account": "Noch kein Konto?",
                        "password_label": "Passwort",
                        "password_placeholder": "Gib dein Passwort ein",
                        "separator": "Oder",
                        "submit": "Anmelden",
                        "title": "Anmelden"
                    },
                    "new_project_modal": {
                        "description": "Gib deinem Fotobuch einen Titel, damit du es später leicht wiederfindest. Du kannst ihn jederzeit ändern.",
                        "submit": "Jetzt gestalten",
                        "title": "Benenne dein Projekt",
                        "title_hint": "{count} / 150",
                        "title_label": "Projekttitel",
                        "title_placeholder": "Z.B. Urlaub {year}, Familienalbum..."
                    },
                    "recent_projects_modal": {
                        "description": "Mach mit einem bestehenden Fotobuchprojekt weiter oder starte ein neues Projekt.",
                        "empty_state": "Du hast noch keine aktuellen Fotobuchprojekte.",
                        "error": "Beim Laden deiner Projekte ist etwas schiefgelaufen.",
                        "loading": "Deine letzten Projekte werden geladen...",
                        "next_page": "Weiter",
                        "open_error": "Das Projekt konnte nicht geöffnet werden. Versuche es erneut.",
                        "open_project": "Projekt öffnen",
                        "opening": "Wird geöffnet...",
                        "pagination": "Seite {page} von {total}",
                        "previous_page": "Zurück",
                        "retry": "Erneut versuchen",
                        "sheet_count": "{count} Seiten",
                        "start_new_project": "Neues Projekt starten",
                        "title": "Letzte Projekte",
                        "updated_at": "Zuletzt bearbeitet: {date}"
                    },
                    "start_ordering": {
                        "loading": {
                            "description": "Wir bereiten den Designer für dich vor.",
                            "label": "Dein Produkt wird vorbereitet..."
                        }
                    },
                    "start_over": {
                        "confirm_modal": {
                            "cancel": "Abbrechen",
                            "confirm": "Ja, neu beginnen",
                            "description": "Dein aktuelles Foto und deine Einstellungen werden gelöscht. Das kannst du nicht rückgängig machen.",
                            "title": "Möchtest du wirklich neu beginnen?"
                        },
                        "label": "Oder neu beginnen, neues Foto wählen"
                    },
                    "upload": {
                        "errors": {
                            "file_too_large": "Dieses Foto ist zu groß. Bitte lade ein Bild von maximal 100 MB hoch.",
                            "generic": "Beim Hochladen ist etwas schiefgelaufen. Bitte versuche es erneut.",
                            "invalid_file_type": "Dieser Dateityp wird nicht unterstützt. Bitte lade ein JPG-, PNG- oder WebP-Bild hoch.",
                            "retry_cta": "Erneut versuchen",
                            "title": "Upload fehlgeschlagen"
                        },
                        "leave_modal": {
                            "cancel": "Hier bleiben",
                            "confirm": "Upload abbrechen",
                            "description": "Dein Foto wird noch hochgeladen. Wenn du die Seite jetzt verlässt, geht dein Fortschritt verloren.",
                            "title": "Möchtest du den Upload wirklich abbrechen?"
                        },
                        "offline": {
                            "description": "Du bist offline. Wir machen weiter, sobald du wieder eine Verbindung hast.",
                            "title": "Keine Verbindung"
                        },
                        "redirecting": {
                            "description": "Sie werden weitergeleitet.",
                            "label": "Upload abgeschlossen!"
                        },
                        "uploading": {
                            "description": "Sie werden automatisch weitergeleitet.",
                            "label": "Ihr Foto wird verarbeitet..."
                        }
                    },
                    "update_cart": {
                        "loading": {
                            "description": "Du wirst automatisch zum Warenkorb weitergeleitet.",
                            "label": "Dein Produkt wird aktualisiert."
                        }
                    },
                    "force_size_selection_message": "Bitte wähle zunächst eine Größe aus.",
                    "force_size_selection_tooltip": "Du musst noch eine Größe auswählen"
                },
                "product_filters": {
                    "choose_option": "Bitte wählen",
                    "make_your_choice": "Triff deine Wahl"
                },
                "product_set": {
                    "available_sizes_label": "Wähle deine Formate",
                    "discount_label": "Set-Rabatt",
                    "position_label": "Bild {number}",
                    "save_label": "Speichern",
                    "standard_sizes_note": "Abbildungen basieren auf Standardformaten"
                },
                "switch_options": {
                    "with_name": "Mit Namen",
                    "without_name": "Ohne Namen"
                }
            },
            "user_text": {
                "error": {
                    "empty": "Kein Text ausgefüllt"
                },
                "label": "Persönlicher Text",
                "placeholder": "Geben Sie Ihren Text ein..."
            },
            "price": {
                "from_abbreviation": "ab",
                "instead_of": "statt"
            },
            "after_upload_text": "Dann: Größe auswählen und Preise ansehen",
            "timer": {
                "label": "{days} Tage und {hours}:{minutes}:{seconds}",
                "last_day_label": "Nur noch {hours} Stunden und {minutes}:{seconds} übrig",
                "one_day_label": "{days} Tag und {hours}:{minutes}:{seconds}"
            },
            "ai_upload": {
                "history": {
                    "loading_previous": "Deine vorherige Version wird geladen",
                    "loading_latest": "Deine neueste Version wird geladen"
                },
                "auth": {
                    "email": {
                        "continue": "Weiter",
                        "context": "Gib deine E-Mail-Adresse ein, um dein eigenes Foto hochzuladen und mit KI generieren zu lassen.",
                        "error": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
                        "placeholder": "Deine E-Mail-Adresse",
                        "title": "Weiter"
                    },
                    "login": {
                        "context": "Für {email} existiert bereits ein Konto. Melde dich an, um fortzufahren.",
                        "forgot_password": "Passwort vergessen?",
                        "general_error": "Anmelden fehlgeschlagen. Überprüfe deine Daten und versuche es erneut.",
                        "password_placeholder": "Gib dein Passwort ein",
                        "submit": "Anmelden",
                        "title": "Anmelden"
                    },
                    "otp": {
                        "general_error": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
                        "intro": "Wir haben einen Bestätigungscode an {email} gesendet.",
                        "resend": "Keinen Code erhalten? Erneut senden",
                        "resend_sent": "Wir haben dir einen neuen Code gesendet.",
                        "submit": "Bestätigen und Foto wählen",
                        "title": "Bestätige deine E-Mail-Adresse",
                        "submit_continue": "Bestätigen"
                    },
                    "success": {
                        "title": "Angemeldet!",
                        "cta": "Wähle dein Foto"
                    }
                },
                "ai_generated_badge": "KI generiert",
                "view_full_screen": "Foto im Vollbild ansehen",
                "button": {
                    "label": "Jetzt gestalten",
                    "choose_photo": "Foto auswählen",
                    "try_again": "Erneut versuchen",
                    "offline": "Du bist offline. Der Upload wird automatisch fortgesetzt, sobald die Verbindung wiederhergestellt ist.",
                    "slow_connection": "Du hast eine langsame Verbindung. Der Upload kann etwas länger dauern.",
                    "add_text": "Name/Text hinzufügen",
                    "edit_text": "Name/Text bearbeiten",
                    "errors": {
                        "invalid_file_type": "Dieser Dateityp wird nicht unterstützt. Lade ein Foto im Format JPG, PNG oder WEBP hoch.",
                        "file_too_small": "Diese Datei ist zu klein. Wähle ein anderes Foto.",
                        "file_too_large": "Diese Datei ist zu groß. Lade ein Foto mit maximal 100 MB hoch."
                    }
                },
                "progress": {
                    "retry": "Erneut versuchen",
                    "retry_different_photo": "Andere Foto hochladen",
                    "beauty_shots_failed": "Leider konnten wir deine Produktvorschauen nicht erstellen. Bitte versuche es erneut.",
                    "image_failed": "Dieses Produktbild konnte nicht erstellt werden.",
                    "overtime": "Das dauert etwas länger als erwartet. Wir arbeiten weiter, bitte noch einen Moment.",
                    "shot_pending": "Dieses Produktfoto wird noch erstellt. Die anderen kannst du schon ansehen.",
                    "creating_previews": "Wir erstellen jetzt deine Produktvorschauen...",
                    "title": "Dein Porträt wird erstellt",
                    "subtitle": "Durchschnittlich 60-90 Sekunden. Bitte etwas Geduld.",
                    "baking_title": "Wir erstellen neue Produktbilder für dich",
                    "bake_progress_title": "Neue Produktbilder werden geladen",
                    "bake_progress_subtitle": "Anhand deines Namens werden neue Produktbilder erstellt.",
                    "preparing_photo_error": "Dein Produktfoto konnte nicht vorbereitet werden. Bitte versuche es erneut.",
                    "preparing_photo_and_cart_title": "Wir legen dein Produkt in den Warenkorb",
                    "preparing_photo_and_cart_description": "Gleichzeitig schließen wir dein persönliches Produktfoto ab.",
                    "beauty_shots_count": "{completed} von {total}",
                    "steps": {
                        "analyzing": "Foto analysieren",
                        "recognizing": "Gesicht erkennen",
                        "styling": "Stil anwenden",
                        "finalizing": "Design fertigstellen",
                        "creating_images": "Bilder werden erstellt",
                        "uploading": "Dein Foto wird verarbeitet",
                        "generating": "Bild wird erstellt",
                        "processing": "Porträt wird fertiggestellt",
                        "processing_plural": "Porträts werden fertiggestellt",
                        "previews": "Produktbilder werden erstellt",
                        "preview_single": "Dein Produktbild wird erstellt",
                        "preview_plural": "Deine Produktbilder werden erstellt",
                        "uploading_busy": "Das dauert etwas länger als erwartet...",
                        "analyzing_busy": "Wir schauen genau hin...",
                        "generating_busy": "Dein Bild wird erstellt...",
                        "generating_busy_plural": "Deine Bilder werden erstellt...",
                        "processing_busy": "Letzte Anpassungen...",
                        "previews_busy": "Deine Produktbilder werden erstellt, gleich fertig...",
                        "baking_text": "Text wird eingebettet...",
                        "baking_style": "Text & Stil verarbeiten",
                        "baking_text_subtitle": "Dein Text wird auf das Porträt übertragen.",
                        "baking_photo": "Produktbild aktualisieren",
                        "addition_activating": "{label}-Stil laden",
                        "addition_transforming": "Porträt umwandeln",
                        "addition_transforming_subtitle": "Dein Porträt wird umgewandelt",
                        "addition_generating": "{label} generieren",
                        "addition_finalizing": "Details fertigstellen",
                        "uploading_subtitle": "Wir bereiten dein Foto vor",
                        "analyzing_subtitle": "Wir schauen, was auf deinem Foto ist",
                        "generating_subtitle": "Die KI erstellt dein Bild",
                        "generating_subtitle_plural": "Die KI erstellt deine Bilder",
                        "processing_subtitle": "Wir geben den letzten Schliff",
                        "addition_activating_subtitle": "Wir laden den gewählten Stil",
                        "uploading_done": "Foto verarbeitet",
                        "analyzing_done": "Foto analysiert",
                        "generating_done": "Bild erstellt",
                        "generating_done_plural": "Bilder erstellt",
                        "processing_done": "Details fertig",
                        "addition_activating_done": "Stil geladen",
                        "addition_transforming_done": "Vorschau fertig"
                    }
                },
                "regenerate": {
                    "title": "Neu generieren",
                    "feedback_placeholder": "\"Realistischer\" oder \"Lebhaftere Farben\"",
                    "with_feedback": "Mit Feedback",
                    "error_generic": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
                    "threshold_exceeded": "Das tägliche Limit für KI-Fotogenerierung wurde erreicht. Bitte versuche es morgen erneut.",
                    "style_additions_generate": "Generieren mit {label}",
                    "style_additions_cost_notice": "Das verbraucht 1 KI-Credit",
                    "style_additions_title": "Ergänzung wählen"
                },
                "crop": {
                    "panel_title": "Gesicht auswählen",
                    "panel_description": "Verwende das Auswahlfeld, um dein Gesicht zu rahmern. So erhältst du das beste Ergebnis.",
                    "image_load_error": "Wir konnten dein Foto nicht laden. Bitte versuche ein anderes Bild.",
                    "zoom_in": "Vergrößern",
                    "zoom_out": "Verkleinern",
                    "validating": "Foto prüfen…",
                    "error_title": "Das hat nicht geklappt"
                },
                "validation": {
                    "retry": "Anderes Foto wählen",
                    "cancel": "Abbrechen",
                    "no_face": {
                        "title": "Gesicht nicht erkannt",
                        "description": "In deinem Ausschnitt konnten wir kein deutliches Gesicht erkennen. Verschiebe die Auswahl auf das Gesicht oder lade ein anderes Foto hoch.",
                        "tip_1": "Schau direkt in die Kamera.",
                        "tip_2": "Achte auf gute Beleuchtung — vermeide Gegenlicht.",
                        "tip_3": "Entferne Sonnenbrillen, Masken oder Mützen."
                    },
                    "no_pet": {
                        "title": "Kein Haustier erkannt",
                        "description": "Wir konnten kein Haustier in deinem Foto erkennen. Bitte lade ein Foto hoch, auf dem dein Haustier gut sichtbar ist."
                    },
                    "mismatch": {
                        "title": "Keine Person erkannt",
                        "description": "In deinem Ausschnitt konnten wir keine Person erkennen. Verschiebe die Auswahl auf das Gesicht oder lade ein anderes Foto hoch.",
                        "tip_1": "Verschiebe die Auswahl, sodass das Gesicht im Rahmen liegt.",
                        "tip_2": "Oder lade ein Foto hoch, auf dem die Person deutlich zu sehen ist."
                    },
                    "unsafe": {
                        "title": "Foto nicht akzeptiert",
                        "description": "Dein Foto entspricht nicht unseren Richtlinien. Bitte lade ein anderes Foto hoch.",
                        "tip_1": "Verwende ein geeignetes, neutrales Portraitfoto."
                    },
                    "unavailable": {
                        "title": "Fotoprüfung nicht verfügbar",
                        "description": "Die Fotoprüfung ist vorübergehend nicht verfügbar. Dein Foto wurde so weitergeleitet.",
                        "tip_1": "Versuche es später erneut, falls Probleme auftreten."
                    }
                },
                "daily_limit_reached": "Die KI-Fotogenerierung ist vorübergehend nicht verfügbar. Bitte versuche es morgen erneut.",
                "user_daily_limit_reached": "Du hast dein KI-Generierungslimit erreicht. Bitte versuche es in 1 Stunde erneut. | Du hast dein KI-Generierungslimit erreicht. Bitte versuche es in {count} Stunden erneut.",
                "related_styles": {
                    "title": "KI-Stile"
                },
                "view_previous_generations": "Vorherige Generierungen ansehen",
                "transfer": {
                    "title": "Vorheriges Foto wiederverwenden",
                    "dismiss": "Anderes Foto verwenden",
                    "generate": "Jetzt generieren",
                    "photo_label": "Dein Foto",
                    "change": "Foto ändern"
                },
                "beauty_shots_generating": "Noch {count} Produktfoto wird erstellt... | Noch {count} Produktfotos werden erstellt...",
                "personalization": {
                    "alignment_label": "Ausrichtung",
                    "weight_label": "Stärke",
                    "reset_text": "Text zurücksetzen",
                    "remove_text": "Text entfernen",
                    "remove_all_text": "Neu anfangen",
                    "weight_300": "Dünn",
                    "weight_400": "Normal",
                    "weight_500": "Mittel",
                    "weight_600": "Halbfett",
                    "weight_700": "Fett",
                    "weight_800": "Extrafett",
                    "weight_900": "Schwarz",
                    "uncommitted_modal_title": "Text noch nicht generiert",
                    "uncommitted_modal_body": "Du hast Text hinzugefügt, aber dieser wurde noch nicht auf das Foto generiert.",
                    "uncommitted_add_without_text": "Ohne Text bestellen",
                    "uncommitted_generate": "Generieren und prüfen",
                    "uncommitted_cancel": "Weiter anpassen",
                    "uncommitted_generate_and_add": "Generieren & weiter",
                    "uncommitted_next_product_options": "Danach wählst du deine Produktoptionen.",
                    "uncommitted_next_redirect_to_cart": "Danach wirst du automatisch zum Warenkorb weitergeleitet.",
                    "active_banner": "Andere Fotos gesperrt",
                    "active_banner_tooltip": "Du befindest dich im Personalisierungsmodus. Klappe die Personalisierung ein, um die anderen Fotos wieder zu sehen, oder generiere eine Vorschau.",
                    "remove": "Text entfernen",
                    "drag_hint": "Zum Verschieben ziehen",
                    "update_preview": "Speichern und Vorschau",
                    "add_text": "Text hinzufügen",
                    "generating": "Wird generiert...",
                    "committed_hint": "Entferne einen Text, um zur ursprünglichen Vorschau zurückzukehren.",
                    "background_padding_label": "Opvulling",
                    "color_label": "Textfarbe",
                    "font_label": "Schriftart",
                    "mode_text": "Text",
                    "preview_mode": "Vorschaumodus – noch nicht generiert",
                    "size_label": "Größe",
                    "text_placeholder": "Dein Text hier",
                    "title": "Text hinzufügen",
                    "title_update": "Personalisierung aktualisieren",
                    "field_label": "Name/Text",
                    "cta_add": "Hinzufügen",
                    "cta_edit": "Bearbeiten",
                    "edit_baked_text": "Text ändern",
                    "edit_baked_notice": "Dein Text ist jetzt Teil des Bildes. Änderst du ihn, erstellen wir die Fotos mit deinem neuen Text neu.",
                    "view_photos": "Alle Fotos ansehen",
                    "mobile_save": "Speichern",
                    "text_done": "Text übernehmen"
                },
                "cycle_limit_go_back": "← Frühere Ergebnisse ansehen",
                "cycle_limit_reached_with_previous_title": "Du hast alle deine Versuche verbraucht",
                "user_limit_reached_unknown_wait": "Du hast dein KI-Generierungslimit erreicht. Bitte versuche es später erneut.",
                "status": {
                    "loading": {
                        "label": "Dein Foto wird hochgeladen",
                        "description": "Danach leiten wir dich automatisch weiter."
                    },
                    "offline": {
                        "title": "Keine Verbindung",
                        "description": "Du bist offline. Wir machen weiter, sobald du wieder eine Verbindung hast."
                    },
                    "errors": {
                        "title": "Upload fehlgeschlagen",
                        "generic": "Beim Hochladen ist etwas schiefgelaufen. Bitte versuche es erneut.",
                        "retry_cta": "Erneut versuchen"
                    }
                }
            }
        },
        "product_options": {
            "preview_alt": "Vorschau",
            "saved_price": "Sie sparen {amount}",
            "title": "Übersicht deines Produkts",
            "preview_loading": "Vorschau wird geladen...",
            "update_cart": "Warenkorb aktualisieren"
        },
        "tools": {
            "add_to_cart_error": {
                "description": "Dein Produkt konnte nicht in den Warenkorb gelegt werden. Keine Sorge — deine Konfiguration ist gespeichert.",
                "retry": "Erneut versuchen",
                "title": "Etwas ist schiefgelaufen"
            },
            "ai": {
                "crop": {
                    "title": "Zuschneiden",
                    "sidebar": "Zuschnitt"
                },
                "select": {
                    "title": "Auswählen",
                    "heading": "Wähle deinen Favoriten",
                    "description": "Wähle die Variante, die dir am besten gefällt.",
                    "candidate_label": "Variante {number}",
                    "name_placeholder": "Dein Name",
                    "candidate_pending": "Diese Variante wird noch erstellt…",
                    "candidate_failed": "Diese Variante konnte nicht erstellt werden.",
                    "candidate_retry": "Erneut versuchen",
                    "candidate_selected": "Ausgewählt",
                    "select_candidate": "Variante {number} auswählen",
                    "view_larger": "Variante {number} vergrößert ansehen",
                    "choose_this": "Diese wählen",
                    "show_all": "Alle meine Bilder anzeigen",
                    "limit_reached": "Du hast dein Generierungslimit erreicht. Wähle aus den Bildern, die du bereits hast.",
                    "regenerate_question": "Nicht zufrieden?",
                    "regenerate": "Zwei neue erstellen",
                    "regenerating": "Zwei weitere werden generiert…",
                    "regenerate_error": "Wir konnten keine weiteren Bilder generieren. Bitte versuche es später erneut.",
                    "save_error": "Wir konnten deine Auswahl nicht speichern. Bitte versuche es erneut."
                },
                "configurator": {
                    "title": "Personalisieren",
                    "sidebar": "Text",
                    "panel_title": "Text hinzufügen",
                    "name_required_hint": "Gib deinen eigenen Namen ein, um fortzufahren.",
                    "view_preview_button": "Vorschau ansehen",
                    "preparing": {
                        "loading": {
                            "label": "Wir erstellen dein Produktbild",
                            "description": "Einen Moment…"
                        }
                    }
                },
                "preview": {
                    "title": "Vorschau",
                    "shot_pending": "Dieses Bild wird noch erstellt…",
                    "shot_failed": "Dieses Bild konnte nicht erstellt werden.",
                    "retry_shot": "Erneut versuchen",
                    "go_to_shot": "Zu Bild {number}",
                    "previous_shot": "Vorheriges Bild",
                    "next_shot": "Nächstes Bild",
                    "view_larger": "Bild {number} vergrößert ansehen",
                    "filling": "Bilder werden erstellt"
                }
            },
            "mediaclip": {
                "configurator": {
                    "choose_size": {
                        "label": "Wählen Sie Ihre Größe"
                    },
                    "custom_size": {
                        "label": "Wählen Sie eine benutzerdefinierte Größe"
                    },
                    "title": "Konfigurator"
                }
            },
            "product_options": {
                "title": "Produktoptionen"
            }
        },
        "success_page": {
            "banner": {
                "title": "Erledigt!",
                "sub_title": "Vielen Dank für Ihre Bestellung. Wir legen sofort los."
            },
            "title": "Wie geht es jetzt weiter?",
            "steps": {
                "order_confirmation": {
                    "title": "Auftragsbestätigung",
                    "description": "Wir senden Ihnen eine Bestellbestätigung (<strong>#{orderNumber}</strong>) an Ihre E-Mail-Adresse. Alle Ihre Bestellungen finden Sie in Ihrem Konto.",
                    "description_fallback": "Wir senden Ihnen eine Bestellbestätigung an Ihre E-Mail-Adresse. Alle Ihre Bestellungen finden Sie in Ihrem Konto.",
                    "summary": {
                        "total_paid": "Bezahlter Gesamtbetrag (inkl. MwSt.)",
                        "total_in_email": "Den bezahlten Betrag finden Sie in Ihrer Bestellbestätigung.",
                        "show": "Bestellung anzeigen",
                        "hide": "Bestellung ausblenden",
                        "discount": "Rabatt",
                        "discount_code": "Gutscheincode {code}",
                        "shipping": "Versandkosten",
                        "free": "Kostenlos",
                        "payment_fee": "Zahlungsgebühr",
                        "other": "Sonstiges",
                        "total": "Gesamt"
                    }
                },
                "shipping_confirmation": {
                    "title": "Versandbestätigung",
                    "description": "Sie erhalten eine E-Mail, sobald Ihre Produkte verpackt und an den Versanddienstleister übergeben wurden.",
                    "delivery_date": "Wird geliefert um"
                },
                "delivery_address": {
                    "title": "Lieferadresse",
                    "description": "Ihre Artikel werden geliefert an",
                    "info": "Lassen Sie die Tür offen; ein Briefkasten oder Posteingang tut es auch."
                },
                "questions": {
                    "title": "Noch Fragen?",
                    "description": "Wir helfen gerne! Schau auf unsere",
                    "customer_service_link": "Kundenservice-Seite",
                    "show_the_wow": {
                        "title": "Zeig den Wow-Effekt!",
                        "description": "Zeig deinen Freunden, womit du dir etwas gegönnt hast!",
                        "instagram_label": "Instagram",
                        "facebook_label": "Facebook"
                    },
                    "news_letter": {
                        "label": "Exklusiv",
                        "title": "Möchten Sie WOW-Mitglied werden?",
                        "usp_1": "10% Rabatt auf deine nächste Bestellung",
                        "usp_2": "Neue Motive und Produkte vor allen anderen entdecken",
                        "usp_3": "Exklusive Gutscheine & Aktionen",
                        "button": "Jetzt Mitglied werden"
                    }
                }
            },
            "page_title": "Bestellung aufgegeben!"
        },
        "checkout_page": {
            "form": {
                "delivery": {
                    "available_from": "Verfügbar ab",
                    "choose_pickup_location": "Wählen Sie Ihren Abholort",
                    "day_after_tomorrow_delivery": "Heute bestellt, <b>übermorgen</b> bei dir!",
                    "deliver_at_pickup_location": "Wählen Sie einen Abholpunkt aus",
                    "error": "Beim Laden der Lieferoptionen ist ein Fehler aufgetreten.",
                    "latest_delivery": "Ihr Paket wird an Ihre Adresse geliefert am",
                    "no_address": "Geben Sie Ihre Lieferadresse ein, um die verfügbaren Versandarten anzuzeigen.",
                    "no_pickup_locations": "Keine Abholpunkte gefunden",
                    "opening_times": {
                        "label": "Öffnungszeiten"
                    },
                    "postal_code_search": {
                        "button": "Suchen",
                        "label": "Postleitzahl",
                        "placeholder": "Postleitzahl eingeben"
                    },
                    "selected_pickup_location": "Ausgewählter Abholort:",
                    "show_on_map": "Auf der Karte anzeigen",
                    "show_other_pickup_locations": "Weitere Abholpunkte anzeigen",
                    "tabs": {
                        "delivery": "Lieferung",
                        "pickup": "Abholpunkt"
                    },
                    "tomorrow_delivery": "Heute bestellt, <b>morgen</b> bei dir!"
                },
                "payment": {
                    "no_address": "Geben Sie Ihre Lieferadresse ein, um die verfügbaren Zahlungsmethoden anzuzeigen.",
                    "no_payment_required": "Keine Zahlung erforderlich.",
                    "no_payment_required_subtitle": "Deine Bestellung wird vollständig durch deinen Gutscheincode abgedeckt."
                }
            },
            "free": "Kostenlos",
            "messages": {
                "errors": {
                    "billing_address_missing": "Ihre Rechnungsadresse ist unvollständig. Bitte überprüfen Sie Ihre Adresse und versuchen Sie es erneut.",
                    "placing_order_failed": "Ihre Bestellung kann momentan nicht aufgegeben werden.",
                    "shipping_address_missing": "Ihre Lieferadresse ist unvollständig. Bitte überprüfen Sie Ihre Adresse und versuchen Sie es erneut."
                }
            },
            "overview": {
                "place_order_button": {
                    "label": "Bestellung aufgeben"
                },
                "prices": {
                    "discount": "Rabatt",
                    "shipping_costs": "Versandkosten",
                    "shipping_surcharge": "Zuschlag",
                    "payment_fee": "Zahlungsgebühr",
                    "subtotal": "Zwischensumme",
                    "total": "Gesamt",
                    "you_save": "Sie sparen",
                    "coupon_code": "Rabattcode",
                    "incl_vat": "inkl. {amount} MwSt.",
                    "promotion_discount": "Aktionsrabatt"
                },
                "quote_items": {
                    "count": "1 Artikel | {count} Artikel",
                    "quantity": "Menge: {quantity}"
                },
                "title": "Übersicht"
            },
            "payment": {
                "most_popular": "Meistgewählt"
            }
        },
        "configurator": {
            "sizes": {
                "most_chosen": "Meistgewählt"
            }
        },
        "search": {
            "title": "Suchergebnisse",
            "title_with_query": "Suchergebnisse für ‘{query}’",
            "products_title": "Produkte",
            "heading_all": "Alle Designs",
            "heading_with_query": "Suchergebnisse für ‘{query}’",
            "heading_no_results": "Keine Ergebnisse für ‘{query}’",
            "subtitle_no_results": "Überprüfen Sie die Schreibweise oder versuchen Sie einen allgemeineren Suchbegriff.",
            "browse_by_product_title": "Nach Produkt durchsuchen"
        }
    },
    "slices": {
        "algolia_slider": {
            "price": {
                "else": "statt",
                "from": "ab"
            }
        },
        "plp_before_after": {
            "before": "Vorher",
            "after": "Nachher"
        },
        "plp_customer_images": {
            "image_alt": "Kundenfoto"
        },
        "pdp_before_after": {
            "before": "Vorher",
            "after": "Nachher"
        },
        "contact_form_business": {
            "gift_timing_placeholder": "Wann möchtest du die Koffer verschenken?*",
            "referral_placeholder": "Wie haben Sie von uns gehört?*",
            "no_options": "Keine Optionen verfügbar",
            "selected_file": "Ausgewählte Datei:",
            "required_fields": "Bitte füllen Sie alle Pflichtfelder aus.",
            "submit_error": "Beim Absenden des Formulars ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
            "invalid_file_type": "Ungültiger Dateityp. Nur JPEG, PNG, GIF, BMP, WEBP oder SVG sind erlaubt."
        },
        "banner_slider": {
            "excellent": "Ausgezeichnet"
        }
    },
    "tools": {
        "mediaclip": {
            "configurator": {
                "designer": {
                    "loading": "Wir bereiten den Konfigurator vor."
                },
                "footer": {
                    "buttons": {
                        "cancel": {
                            "label": "Abbrechen"
                        },
                        "change_size": {
                            "label": "Größe ändern ({size})"
                        },
                        "choose_size": {
                            "label": "Größe wählen"
                        },
                        "to_photo": {
                            "label": "Zu Foto {number}"
                        }
                    }
                },
                "hexagon_photos_required_modal": {
                    "title": "Fotos fehlen",
                    "description": "Fotos {list} sind noch nicht ausgefüllt. Klicke auf ein leeres Feld, lade dein Foto hoch und versuche es erneut.",
                    "letter_collage_description": "Noch nicht alle Felder haben ein Foto. Klicke auf ein leeres Feld, lade dein Foto hoch und versuche es erneut.",
                    "close": "Verstanden"
                },
                "connection_lost_modal": {
                    "title": "Verbindung unterbrochen",
                    "description": "Wir können dein Design gerade nicht erreichen. Überprüfe deine Internetverbindung und lade die Seite neu; dein Design wird automatisch gespeichert.",
                    "reload": "Seite neu laden"
                },
                "project_title": {
                    "error": "Speichern fehlgeschlagen",
                    "label": "Projekttitel",
                    "placeholder": "Projektnamen eingeben...",
                    "saved": "Gespeichert",
                    "saving": "Wird gespeichert..."
                }
            }
        },
        "landscape_popup": {
            "text": "Diese Seite funktioniert besser, wenn Sie den Bildschirm drehen. Bitte drehen Sie Ihren Bildschirm, um weiterzumachen."
        }
    }
}
